import React from "react";

import Icon       from "_components/atoms/icon";
import Image      from "_components/atoms/image";
import Typography from "_components/atoms/typography";

import useStyles from "./styles";

export default React.memo ( function FanScoreCard ( { authorProfileImage, authorName, fanRank, points, isCurrentUser, isSessionEnded, coins, profileHref } ) {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	if ( !isSessionEnded ) {
		return (
			<div className = { fanRank === 1 || fanRank === 2 || fanRank === 3 ? classes.secondThirdFan : classes.container }>

				<div className = { classes.fanContainer }>
					<div className = { classes.topSection }>
						<div className = { classes.sectionLeft }>
							<div className = { fanRank === 1 || fanRank === 2 || fanRank === 3 ? classes.secondThirdRankText : classes.rankText }>
								{
									fanRank === 1 ? (
									// <FanRank1Icon className = { classes.svgOneIcon } />
										<Icon sameInBothTheme
											className = { classes.svgOneIcon }
											name      = "fanRank1"
										>
										</Icon>
									) : fanRank === 2 ? (
										<Icon sameInBothTheme
											className = { classes.svgIcon }
											name      = "fanRank2"
										>
										</Icon>
									) : fanRank === 3 ? (
										<Icon sameInBothTheme
											className = { classes.svgIcon }
											name      = "fanRank3"
										/>
									) : (
										<Typography
											className = { isCurrentUser ? classes.ownUserFanRank : "fontWeightBold" }
											title     = { fanRank }
											variant   = "body1"
										/>
									)
								}
							</div>

							<a className = { classes.avatarContainer }
								href        = { profileHref }
								rel         = "noreferrer"
								target      = "_blank"
							>
								<div className = { classes.avatar }>
									<Image className = { classes.img }
										src             = { authorProfileImage }
									/>
								</div>
							</a>

							<a className = { classes.nameContainer }
								href        = { profileHref }
								rel         = "noreferrer"
								target      = "_blank"
							>
								<Typography
									className = { isCurrentUser ? classes.ownUserName : classes.normalUserName }
									title     = { authorName }
									// color     = { isCurrentUser ? "textSecondary":"primary" }
								/>
							</a>

						</div>

						<div>
							<Typography
								className = { isCurrentUser ? classes.fanRankSelfPoints : classes.fanRankPoint }
								title     = { Math.round ( points * 10 ) / 10 }
								variant   = "body2"
							/>
						</div>
					</div>

					<div className = { classes.borderStyles }></div>
				</div>
			</div>
		);
	}

	return (
		<div className = { fanRank === 1 ? classes.endedFanRank1 : fanRank === 2 ? classes.endedFanRank2 : fanRank === 3 ? classes.endedFanRank3 : classes.container }>
			<div className = { classes.fanContainer }>
				<div className = { classes.topSection }>
					<div className = { classes.sectionLeft }>
						<div className = { fanRank === 2 || fanRank === 3 ? classes.secondThirdRankText : classes.rankText }>
							{
								fanRank === 1 ? (
									<Icon sameInBothTheme
										className = { classes.endedSvgIconRank1 }
										name      = "fanRank1White"
										size      = { 20 }
									>
									</Icon>
								) : fanRank === 2 ? (
									<Icon sameInBothTheme
										className = { classes.endedSvgIcon }
										name      = "fanRank2White"
										size      = { 20 }
									>
									</Icon>
								) : fanRank === 3 ? (
									<Icon sameInBothTheme
										className = { classes.endedSvgIcon }
										name      = "fanRank3White"
										size      = { 20 }
									>
									</Icon>
								) : (
									<Typography
										className = "fontBold"
										title     = { fanRank }
										// color     = { isCurrentUser ? "textSecondary":"primary" }
									/>
								)
							}
						</div>

						<div className = { classes.avatarContainer }>
							<div className = { classes.avatar }>
								<Image className = { classes.img }
									src             = { authorProfileImage }
								/>
							</div>
						</div>

						<div className = { classes.nameContainer }>
							<Typography
								className = { `${ fanRank === 1 || fanRank === 2 || fanRank === 3 ? "whiteText fontBold" : "fontBold" }` }
								color     = { isCurrentUser ? "textSecondary" : "primary" }
								title     = { authorName }
								variant   = "body2"
							/>

							{fanRank === 1 || fanRank === 2 || fanRank === 3 ? (
								<Typography
									className = "whiteText"
									color     = { isCurrentUser ? "textSecondary" : "primary" }
									title     = { points }
									variant   = "body2"
								/>
							) : null}
						</div>
					</div>

					{fanRank === 1 || fanRank === 2 || fanRank === 3 ? (
						<div style = { { display: "flex", alignItems: "center" } }>
							<Typography
								className = "whiteText fontBold"
								color     = { isCurrentUser ? "textSecondary" : "primary" }
								title     = { coins }
								variant   = "body1"
							/>

							<Icon sameInBothTheme
								className = { classes.coinsIcon }
								name      = "fanCoin"
							>
							</Icon>
						</div>

					) : (
						<div>
							<Typography
								className = { classes.fanRankPoint }
								color     = { isCurrentUser ? "textSecondary" : "primary" }
								title     = { Math.round ( points * 10 ) / 10 }
								variant   = "body2"
							/>
						</div>
					)}
				</div>

				{fanRank !== 1 && fanRank !== 2 && fanRank !== 3 && ( <div className = { classes.borderStyles }></div> )}
			</div>
		</div>
	);
} );

export const CurrentScoreCard = ( { authorName, authorProfileImage, fanRank, isCurrentUser, points, profileHref } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.currenRankContainer }>
			<div className = { classes.currentTopSection }>
				<div className = { classes.sectionLeft }>
					<div className = { classes.rankText }>

						<Typography
							className = { "fontBold colorWhite" }
							title     = { fanRank }
							variant   = "body1"
						/>

					</div>

					<a className = { classes.avatarContainer }
						href        = { profileHref }
						rel         = "noreferrer"
						target      = "_blank"
					>
						<div className = { classes.avatar }>
							<Image className = { classes.img }
								src             = { authorProfileImage }
							/>
						</div>
					</a>

					<a className = { classes.nameContainer }
						href        = { profileHref }
						rel         = "noreferrer"
						target      = "_blank"
					>
						<Typography
							className = { "fontBold colorWhite" }
							title     = { authorName }
						/>
					</a>

				</div>

				<div>
					<Typography
						className = { `${ classes.fanRankPoint } colorWhite` }
						color     = { isCurrentUser ? "textSecondary" : "primary" }
						title     = { Math.round ( points * 10 ) / 10 }
						variant   = "body2"
					/>
				</div>
			</div>
		</div>
	);
};
